<template><div><h1>inline manifest</h1>
<div class="tip">
<p><code>manifest</code> 文件为路径配置和异步组件名字列表，该做法可以减少一个<code>http</code>请求。</p>
<p>确保 <code>vux-loader</code>更新到 <code>^1.0.35</code>。</p>
</div>
<h2>修改 index.html 模板</h2>
<p>首先在页面的<code>&lt;/body&gt;</code>前加入代码：</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">%=htmlWebpackPlugin.files.webpackManifest%</span>&gt;</span>
</code></pre>
<h2>配置 vux-loader</h2>
<p>在<code>vux-loader</code>配置的 <code>plugins</code> 列表中加入<code>inline-manifest</code>插件</p>
<pre class="hljs"><code>plugins:[{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'inline-manifest'</span>
}]
</code></pre>
<p>或者简化写法直接使用名字：</p>
<pre class="hljs"><code>plugins:[<span class="hljs-string">'inline-manifest'</span>]
</code></pre>
</div></template><script>
export default {
  head: {"title":"Vue 打包优化：使用 inline manifest | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// inline-manifest-302.vue?f6205f34